import "core-js/modules/es.array.filter";
import "core-js/modules/es.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { dispatchStorePage } from '@/store/dispatches';

var ListPage = /*#__PURE__*/function (_Vue) {
  _inherits(ListPage, _Vue);

  var _super = _createSuper(ListPage);

  function ListPage() {
    var _this;

    _classCallCheck(this, ListPage);

    _this = _super.apply(this, arguments);
    _this.options = {};
    _this.filter = {};
    _this.windowSize = {
      w: 0,
      h: 0
    };
    _this.actionsHeight = 51;
    return _this;
  }

  _createClass(ListPage, [{
    key: "restorePage",
    value: function () {
      var _restorePage = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(cache) {
        var _JSON$parse, options, filter;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (cache) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _JSON$parse = JSON.parse(cache), options = _JSON$parse.options, filter = _JSON$parse.filter;
                this.options = options;
                this.filter = filter;

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function restorePage(_x) {
        return _restorePage.apply(this, arguments);
      }

      return restorePage;
    }()
  }, {
    key: "storePage",
    value: function () {
      var _storePage = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this$$route$name;

        var options, filter;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                options = this.options, filter = this.filter;
                dispatchStorePage({
                  page: (_this$$route$name = this.$route.name) !== null && _this$$route$name !== void 0 ? _this$$route$name : '',
                  options: options,
                  filter: filter
                });

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function storePage() {
        return _storePage.apply(this, arguments);
      }

      return storePage;
    }()
  }, {
    key: "onResize",
    value: function onResize() {
      this.windowSize = {
        w: window.innerWidth,
        h: window.innerHeight
      };
      var actionDom = this.$refs.actions;
      this.actionsHeight = actionDom.clientHeight;
    }
  }]);

  return ListPage;
}(Vue);

ListPage = __decorate([Component], ListPage);
export default ListPage;